import { Component, OnInit , CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import { ApplicationActions, PaymentActions } from '@app/core/ngrx/actions';
import { State } from '@app/core/ngrx/reducers';
import { applicationSelectors, paymentSelectors } from '@app/core/ngrx/selectors';
import { getState } from '@app/core/ngrx/utils/state';
import { PaymentService } from '@app/core/services/payment/payment.service';
import { queryEncrypt } from '@app/shared/utils/random';
import { WarningService } from '@core/services/warning/warning.service';
import { LoadingController } from '@ionic/angular';
import { Store } from '@ngrx/store';
import { forkJoin, of } from 'rxjs';
import { flatMap } from 'rxjs/operators';
import { ModalController } from '@ionic/angular';
import PaymentApplication from '@Interfaces/PaymentApplication';
import { Angulartics2GoogleTagManager } from 'angulartics2';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@Component({
    selector: 'app-coupon-code',
    templateUrl: './payment-coupon.component.html',
    styleUrls: ['./payment-coupon.component.scss'],
    standalone: true,
    imports: [CommonModule, FormsModule, ReactiveFormsModule, IonicModule],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]})
export class PaymentCouponCodeComponent implements OnInit {
    constructor(
        private warning: WarningService,
        private store: Store<State>,
        private paymentService: PaymentService,
        private loadingController: LoadingController,
        private modalController: ModalController,
        private angulartics2GoogleTagManager: Angulartics2GoogleTagManager
    ) {}

    //
    couponResponse: any = {};
    //
    couponCode: string;
    //
    applicationSelectList$ = this.store.select(paymentSelectors.getPaymentSelectList);
    // local copy of applications to loop over
    LocalApplicationList: any[] = [];
    // need a 2nd array so when bad ids are filtered we have a copy of applications
    LocalApplicationDisplayList: any[] = [];
    //
    // list of ids user wants to apply coupon to
    checkboxList: any[] = [];
    // coupon type
    coupon_type: string;
    //
    coupon_discount: any;

    ngOnInit() {
        this.listenerCouponCode();
    }

    trackByIndex = (index: number): number => index;

    listenerCouponCode() {
        this.applicationSelectList$.subscribe((list: Array<PaymentApplication>) => {
            //
            // console.log('ALL AVAILABLE: ', list);
            // init local application list
            // current list of applications the user can pay for
            this.LocalApplicationList = list
                .filter((a) => a.states !== 'Pre-Approved')
                .map((a) => {
                    return { ...a };
                });
            //
            this.LocalApplicationDisplayList = list
                .filter((a) => a.states !== 'Pre-Approved')
                .map((a) => {
                    return { ...a };
                });
            //
        });
    }

    async submitCode(event: any) {
        // Angulartics Event: paymentCouponCodeSubmitBtnClick
        this.angulartics2GoogleTagManager.eventTrack('paymentCouponCodeSubmitBtnClick', { category: 'Payments', label: this.couponCode });

        const loading = await this.loadingController.create({
            // cssClass: 'my-custom-class',
            message: 'Please wait...',
            duration: 2000,
        });
        // loading controller
        await loading.present();

        //
        //
        let local_applications: any[] = [];
        // get all the applications in current list
        this.applicationSelectList$
            .pipe(
                flatMap((applications: Array<PaymentApplication>) => {
                    local_applications = applications.filter((a) => a.states !== 'Pre-Approved').map((a) => a);
                    return forkJoin(
                        applications
                            .filter((a) => a.states !== 'Pre-Approved')
                            .map((item) => this.paymentService.couponVerify(item.paymentType, item.id, this.couponCode))
                    );
                })
            )
            .subscribe((response: any) => {
                // response is an array of coupoon results against each application
                //  console.log('COUPON RESPONSE: ' , response);

                // if there is at least 1 good coupon in the response we need to focus on it
                let GoodCouponResult = response.find((a: any) => a.validcoupon === true);
                //
                // if there is a bad result with a good result we can ignore the bad
                let BadCouponResult = response.find((a: any) => a.validcoupon === false);
                // if there are only bad results we need to inform the user the code did not work
                //
                // conditional for when request contains a good result

                if (GoodCouponResult) {
                    // target the good result
                    this.couponResponse = GoodCouponResult;
                    this.coupon_type = GoodCouponResult.type;
                    this.coupon_discount = GoodCouponResult.discount;

                    // ANgulartics Event: paymentCouponCodeValidCouponResult
                    this.angulartics2GoogleTagManager.eventTrack('paymentCouponCodeValidCouponResult', { category: 'Payments', label: this.couponCode });

                    // get all the good application ids that came back
                    let GoodApplicationIDs = response.filter((i) => i.result).map((i) => i.applicationid);
                    //
                    let GoodApplications = [];
                    //
                    //
                    // console.log('GOOD APPLICATION IDS: ', GoodApplicationIDs);

                    for (let i = 0; i < this.LocalApplicationList.length; i++) {
                        // console.log(this.LocalApplicationList);
                        let local_app: PaymentApplication = this.LocalApplicationList[i];
                        // console.log(local_app);
                        if (GoodApplicationIDs.indexOf(local_app.id) >= 0) {
                            // console.log('was good');
                            GoodApplications.push({
                                ...local_app,
                                isCouponDisabled: false,
                            });
                        } else {
                            GoodApplications.push({
                                ...local_app,
                                isCouponDisabled: true,
                                message: response.find((app) => app.applicationid === local_app.applicationid).message,
                            });
                        }
                    }
                    //
                    // console.log('good applications result: ' , GoodApplications);

                    //
                    this.LocalApplicationDisplayList = GoodApplications.map((a) => {
                        return { ...a };
                    });
                } else {
                    // console.log('BAD COUPON RESULT');
                    //
                    this.couponResponse = BadCouponResult;

                    // Angulartics Event: paymentCouponInvalidCouponResult
                    this.angulartics2GoogleTagManager.eventTrack('paymentCouponInvalidCouponResult', { category: 'Payments', label: this.couponCode });

                    // disable list is present
                    if (this.LocalApplicationDisplayList.length > 0) {
                        let TempList = this.LocalApplicationDisplayList.map((application: PaymentApplication) => {
                            return {
                                ...application,
                                isCouponDisabled: true,
                            };
                        });
                        //
                        this.LocalApplicationDisplayList = TempList.map((application: PaymentApplication) => {
                            return { ...application };
                        });
                    }
                }

                //
            });
    }

    checkboxCoupon(event: any, application: any) {
        // push on first item
        if (this.checkboxList.length === 0) {
            //
            this.checkboxList.push({
                applicationid: application.id,
                paymenttype: application.paymentType,
            });
        } else {
            // find if id is already in array
            let index = this.checkboxList.findIndex((a) => a.applicationid === application.id);
            //
            // if index is greater or equal to 0 remove id
            if (index >= 0) {
                // remove id
                this.checkboxList.splice(index, 1);
            } else {
                this.checkboxList.push({
                    applicationid: application.id,
                    paymenttype: application.paymentType,
                });
            }
        }
    }

    /**
     *
     * @param event
     */
    async applyCoupon(event: any) {
        // Angulartics Event: paymentCouponCodeApplyBtnClick
        this.angulartics2GoogleTagManager.eventTrack('paymentCouponCodeApplyBtnClick', { category: 'Payments' });

        //
        const loading = await this.loadingController.create({
            // cssClass: 'my-custom-class',
            message: 'Please wait...',
            duration: 2000,
        });
        // loading controller
        await loading.present();

        //
        forkJoin(this.checkboxList.map((item) => this.paymentService.coupon(item.paymenttype, item.applicationid, this.couponCode))).subscribe(
            (response: any) => {
                this.modalController.dismiss({
                    result: response,
                    checkedList: this.checkboxList.map((i) => i),
                    code: this.couponCode,
                    type: this.coupon_type,
                    discount: this.coupon_discount,
                });
            }
        );
    }

    dismiss() {
        this.modalController.dismiss({ result: false });
    }
}
